import { SVGProps, Ref, forwardRef } from 'react';

export const MailBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M10.108 7.998a2.106 2.106 0 1 1-4.213-.001 2.106 2.106 0 0 1 4.213 0M8.002 1A7.01 7.01 0 0 0 1 8.002C1 11.863 4.141 15 8.002 15a6.96 6.96 0 0 0 3.944-1.22l.022-.013-.943-1.097-.018.01c-.899.574-1.934.88-3.005.88A5.57 5.57 0 0 1 2.44 7.999a5.57 5.57 0 0 1 5.563-5.563 5.57 5.57 0 0 1 5.563 5.563q0 .598-.131 1.198c-.176.723-.68.943-1.062.912s-.83-.303-.834-.97v-1.14a3.545 3.545 0 0 0-3.54-3.54 3.544 3.544 0 0 0-3.54 3.54 3.545 3.545 0 0 0 3.54 3.54c.947 0 1.838-.373 2.51-1.044.39.606 1.026.987 1.75 1.044.061.005.127.01.189.01a2.38 2.38 0 0 0 1.421-.48c.421-.32.733-.78.904-1.333.026-.088.079-.294.079-.294v-.009c.1-.443.149-.886.149-1.434C15.004 4.14 11.863 1 8.002 1"
                fill="#0077FF"
            />
        </g>
    </svg>
));
MailBrandSize16Glyph.displayName = 'MailBrandSize16Glyph';
